import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from 'src/app/core/app-settings/app-settings.service';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { UserSessionService } from './shared/user-session.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  clientID: string = '';
  tenantCode: string = '';
  resourceKeyValue: any = {};
  isFacilityConfigured: boolean;
  lblNotAuthorizedInstruction3: string = '';
  lblNotAuthorizedInstruction4: string = '';
  constructor(
    private resourcesService: ResourcesService,
    private appSettings: AppSettingsService,
    private userSessionService: UserSessionService,
  ) { }

  ngOnInit(): void {   
    //Get client Id from AppSettings
      this.clientID = this.appSettings.clientId;

    //Get the resources
    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.setControlValues();
    });

    this.getUserSession();
  }
  getUserSession(): void {
    this.userSessionService.getUserSession()
      .subscribe((session) => {
        if (session) {
          this.tenantCode = session.idmIdnCode;
          this.isFacilityConfigured = session?.facilityId ? true : false;
        }
      })
  }
  getUserManagementUrl(): void {
    //Get idmUrl from AppSettings
    const idmUrl = this.appSettings.idmAuthPortalUrl;
    const IDMSubUrl = this.clientID && this.tenantCode ? `${idmUrl}/dashboard/main/(dashboard:users)?client_id=${this.clientID}&TenantCode=${this.tenantCode}` : idmUrl;
    window.location.href = this.removeBlanks(IDMSubUrl);
  }

  removeBlanks(str: string) {
    return str.replace(/\s/g, "");
  }
  setControlValues(): void {
    this.lblNotAuthorizedInstruction3 = this.resourceKeyValue.lblNotAuthorizedInstruction3;
    this.lblNotAuthorizedInstruction4 = this.resourceKeyValue.lblNotAuthorizedInstruction4;
  }
}